import { createIsDeniedFor, type TicketResource, updateIsDeniedFor } from "@msuite/citadel";
import { useCitadel } from "@/hooks/use-citadel";

/**
 * The fixed ticket rule as every ticket surface asks it: creating, changing and arranging a
 * project's tickets belongs to its members, their active substitutes, and admins — no grant is
 * involved, so both predicates answer from `Citadel.canEditTickets`. Only a definitive denial
 * counts: rules still loading keep the control, the same three-state guard `Can` documents.
 *
 * @returns Two predicates, each `true` only when the caller's relationship refuses.
 */
export function useTicketRules() {
	/** Query */
	const { citadel } = useCitadel();

	/** Functions */
	function updateIsDenied(ticket: TicketResource) {
		if (!citadel) return false;
		return updateIsDeniedFor(citadel, ticket);
	}

	function createIsDenied(projectId: string | null, projectOrgId?: string | null) {
		return createIsDeniedFor(citadel, projectId, projectOrgId);
	}

	/** Return */
	return { updateIsDenied, createIsDenied };
}
